export const QUERY_STALE_TIME = {
  reference: 5 * 60 * 1000,
  standard: 60 * 1000,
  dashboardDetail: 30 * 1000,
  dashboardSummary: 2 * 60 * 1000,
} as const;

export const QUERY_INTERVAL = {
  dashboardLive: 60 * 1000,
} as const;

export const qk = {
  systemSettings: () => ["system-settings"] as const,
  subscriptionCurrent: () => ["subscription-current"] as const,
  subscriptionPlans: () => ["subscription-plans"] as const,
  userModules: () => ["user-modules"] as const,
  availablePaymentMethods: () => ["available-payment-methods"] as const,
  serviceCategories: () => ["service-categories"] as const,
  productCategories: () => ["product-categories"] as const,
  customers: () => ["customers"] as const,
  staffs: () => ["staffs"] as const,
  services: (scope?: string) => (scope ? (["services", scope] as const) : (["services"] as const)),
  bookings: (scope?: string) => (scope ? (["bookings", scope] as const) : (["bookings"] as const)),
  booking: (bookingId: string) => ["booking", bookingId] as const,
  dashboardBookingsRoot: () => ["dashboard-bookings"] as const,
  dashboardBookings: (dateKey: string) => ["dashboard-bookings", dateKey] as const,
  dashboardDepositBookings: () => ["dashboard-deposit-bookings"] as const,
  bookingActivity: () => ["booking-activity"] as const,
} as const;
